<template>
    <div>
        <div v-if="!addToggle" class="px-3 px-sm-5 py-4">
            <div class="text-right mt-3 mb-3">
                <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" :title="$t('button_link.add') + $t('subMenu.salon_menu_treatment')" @click="addToggle = !addToggle">
                    <span class="fal fa-plus mr-2"></span>
                    <span>{{$t('button_link.add')}}{{$t('subMenu.salon_menu_treatment')}}</span>
                </button>
            </div>
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 p-3">
                    <div class="ml-auto mb-3 text-right">
                        <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                            :data="exportData"
                            :fields="exportFields"
                            :header="exportHeaders"
                            type="csv"
                            :escapeCsv="false"
                            :name="exportFileName">
                            <span>CSV</span>
                        </exportCSV>
                        <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                            <span class="mr-3">PDF</span>
                            <i class="arrow-down fas fa-angle-down"></i> 
                        </button> -->
                    </div>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">{{$t('table.no_records')}}</div>
                        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                            <div class="row justify-content-end mt-2">
                                <div class="col-auto pt-2">
                                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                                </div>
                                <div class="col-auto">
                                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
                                </div>
                            </div>
                            <div v-if="!isSpinnerShow && totalEntries != 0" class="row">
                                <div class="col-sm-12 overflow-auto" >
                                    <table class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline" role="grid" style="height: 1px">
                                    <thead class="thead-themed">
                                        <tr>
                                            <th v-for="tblHeader in fields" :key="tblHeader.key">
                                                {{tblHeader.label}}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody v-for="(items, l ) in treatmentItems" :key="l">
                                        <tr class="dtrg-group dtrg-start">
                                            <td class="text-capitalize fs-md border-top-bottom-2 align-middle">
                                                <span class="mr-3 fw-700">{{l+1}}.</span>
                                            </td>
                                            <td style="width: 12%" class="text-capitalize fs-md border-top-bottom-2 border-bottom-0  align-middle">
                                                <div v-if="items.TnTherapy.length == 0">
                                                    <span v-if="items.TnTreatmentImage == ''">-</span>
                                                    <img v-else class="img-fluid img-thumbnail" :src="getImage(items.TnTreatmentImage)"/>
                                                </div>
                                            </td>
                                            <td class="text-capitalize fs-md border-top-bottom-2 align-middle">
                                                <span class="text-primary fw-500">
                                                    {{items.TnTreatmentName}}
                                                </span>
                                            </td>
                                            <td colspan="3" class="align-middle border-top-bottom-2 fs-md fw-300">
                                                {{items.TnTreatmentDetails == '' ? '-' : items.TnTreatmentDetails}}
                                            </td>
                                            <td class="align-middle border-top-bottom-2 border-bottom-0 fs-sm text-center">
                                                <div v-if="items.TnTherapy.length == 0" class="row">
                                                    <div class="col">
                                                        <span class="badge badge-warning">{{$t('table.value.min')}}</span>
                                                        <span class="d-block">{{formatPrice(items.TnTreatmentMinPrice)}}</span>
                                                    </div>
                                                    <div class="col pl-0 pr-0">
                                                        <i class="fal fa-minus"></i>
                                                    </div>
                                                    <div class="col">
                                                        <span class="badge badge-warning">{{$t('table.value.max')}}</span>
                                                        <span class="d-block">{{formatPrice(items.TnTreatmentMaxPrice)}}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="align-middle border-top-bottom-2 border-bottom-0 fs-sm text-center">
                                                <span v-if="items.TnTherapy.length == 0" class="badge" :class="items.TnTreatmentActive == 1 ? 'badge-primary' : 'badge-secondary'">
                                                    {{items.TnTreatmentActive == 1 ? $t('table.value.active') : $t('table.value.inactive')}}
                                                </span>
                                            </td>
                                            <td class="align-middle border-top-bottom-2 fs-sm text-center" :class="{'border-bottom-0': items.TnTherapy.length != 0}">
                                                <div v-if="items.TnTherapy.length == 0">
                                                    <a class="link text-primary mr-3" :title="$t('button_link.edit') + $t('subMenu.salon_menu_treatment')" @click="showEdit(items)">
                                                        <i class="fal fa-cog"></i>
                                                    </a>
                                                    <a class="link text-primary" :title="$t('button_link.delete') + $t('subMenu.salon_menu_treatment')" @click="showDelete(items)">
                                                        <i class="fal fa-trash"></i>
                                                    </a>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="items.TnTherapy.length == 0">
                                            <td class="pt-2 pb-2" colspan="9">
                                                <span class="p-1 bg-warning-500 text-dark fw-500">{{$t('table.no_records')}}</span>
                                            </td>
                                        </tr>
                                        <tr v-for="(item, i) in items.TnTherapy[0]" :key="i">
                                            <td class="align-middle fw-300">{{i+1}}.</td>
                                            <td style="width: 12%;" :rowspan="items.TnTherapy[0].length" v-if="items.TnTherapy[0].length - i == items.TnTherapy[0].length" class="align-middle border-top-0">
                                                <span v-if="items.TnTreatmentImage == ''">-</span>
                                                <img v-else class="img-thumbnail" :src="getImage(items.TnTreatmentImage)"/>
                                            </td>
                                            <td class="align-middle">
                                                {{item.TnTherapyName}}
                                            </td>
                                            <td class="align-middle fw-300">
                                                {{item.TnTherapyDetails == '' ? '-' : item.TnTherapyDetails}}
                                            </td>
                                            <td class="align-middle">
                                                <span class="badge badge-success">{{item.TnTherapyVoucherName}}</span>
                                            </td>
                                            <td class="align-middle">
                                                {{formatPrice(item.TnTherapyUnitPrice)}}
                                            </td>
                                            <td :rowspan="items.TnTherapy[0].length" v-if="items.TnTherapy[0].length - i == items.TnTherapy[0].length" class="text-center border-top-0 align-middle">
                                                <div class="row">
                                                    <div class="col">
                                                        <span class="badge badge-warning">{{$t('table.value.min')}}</span>
                                                        <span class="d-block">{{formatPrice(items.TnTreatmentMinPrice)}}</span>
                                                    </div>
                                                    <div class="col pl-0 pr-0">
                                                        <i class="fal fa-minus"></i>
                                                    </div>
                                                    <div class="col">
                                                        <span class="badge badge-warning">{{$t('table.value.max')}}</span>
                                                        <span class="d-block">{{formatPrice(items.TnTreatmentMaxPrice)}}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td :rowspan="items.TnTherapy[0].length" v-if="items.TnTherapy[0].length - i == items.TnTherapy[0].length" class="text-center border-top-0 align-middle">
                                                <span class="badge" :class="items.TnTreatmentActive == 1 ? 'badge-primary' : 'badge-secondary'">
                                                    {{items.TnTreatmentActive == 1 ? $t('table.value.active') : $t('table.value.inactive')}}
                                                </span>
                                            </td>
                                            <td :rowspan="items.TnTherapy[0].length" v-if="items.TnTherapy[0].length - i == items.TnTherapy[0].length" class="text-center border-top-0 align-middle">
                                                <a class="link text-primary mr-3" :title="$t('button_link.edit') + $t('subMenu.salon_menu_therapy')" @click="showEdit(items)">
                                                    <i class="fal fa-cog"></i>
                                                </a>
                                                <a class="link text-primary" :title="$t('button_link.delete') + $t('subMenu.salon_menu_therapy')" @click="showDelete(items)">
                                                    <i class="fal fa-trash"></i>
                                                </a>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr">
                    <h2>{{$t('button_link.add')}}{{$t('subMenu.salon_menu_treatment')}}</h2>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <treatmentForm :isEdit="false" @returnTreatment="returnTreatment"></treatmentForm>
                    </div>
                </div>
            </div>
        </div>
        <treatmentTherapyForm ref="treatmentTherapyForm" @returnTreatment="returnTreatment"></treatmentTherapyForm>
        <!-- <div :class="{'show': editToggleModal }" class="modal fade">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4 text-capitalize">{{$t('header.edit') + $t('subMenu.salon_menu_treatment')}}
                            <small class="m-0 text-muted">{{$t('subMenu.salon_menu_treatment')}} - "{{sTitle}}"</small>
                        </h5>
                        <button type="button" class="close" @click="editToggleModal = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <treatmentForm ref="treatmentForm" :isEdit="true" @returnTreatment="returnTreatment"></treatmentForm>
                    </div>
                </div>
            </div>
        </div> -->
        <deleteModal ref="deleteModal" @performConfirmAction="deleteTreatment"></deleteModal>
    </div>
</template>
<script>
import _ from 'lodash'
import moment from 'moment'
import TreatmentForm from './Treatment_Form'
import TreatmentTherapyForm from './Treatment_Therapy_Form'
import DeleteModal from './../../Delete_Modal'
import {formatPrice} from './../../../../assets/js/dashboard/utilities'
import {setReturnData, handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'treatment',
    components:{
        TreatmentForm, TreatmentTherapyForm, 
        DeleteModal
    },
    data(){
        return{
            addToggle: false, editToggleModal: false,
            isSpinnerShow: false,
            sTitle: "", itemID: 0, 
            treatmentItems: [],
            selectedTherapy: [],
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
            exportHeaders: [], exportData: [], exportFileName: "", treatmentExportData: []
        }   
    },
    computed:{
        fields(){
            return [
                { key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "TnTreatmentImage", label: this.$i18n.t('table.header.image'), thClass: 'thead-themed align-middle', tdClass: 'width-12'},
                { key: "TnTreatmentName", label: this.$i18n.t('subMenu.salon_menu_treatment'), thClass: 'thead-themed align-middle', tdClass: 'width-12'},
                // { key: "TnTherapyName", label: this.$i18n.t('subMenu.salon_menu_therapy'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "TnTreatmentDetails", label: this.$i18n.t('label.details'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "TnTherapyVoucherName", label: this.$i18n.t('table.header.voucher'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "TnTherapyUnitPrice", label: this.$i18n.t('label.unit_price'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "price", label: this.$i18n.t('table.header.price'), thClass: 'thead-themed align-middle', tdClass: 'align-middle text-center', sortable: true},
                { key: "TnTreatmentActive", label: this.$i18n.t('table.header.active'), thClass: 'thead-themed align-middle text-center', tdClass: 'align-middle text-center'},
                { key: "action", label: "", thClass: 'thead-themed align-middle text-center', tdClass: 'align-middle text-center'},
            ]
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('subMenu.salon_menu_treatment')).toUpperCase()] = "treatment"
            ret[(this.$i18n.t('subMenu.salon_menu_therapy')).toUpperCase()] = "therapy"
            ret[(this.$i18n.t('label.details')).toUpperCase()] = "details"
            ret[(this.$i18n.t('table.header.voucher')).toUpperCase()] = "voucher"
            ret[(this.$i18n.t('label.unit_price')).toUpperCase()] = "unitPrice"
            ret[(this.$i18n.t('table.header.price') + '(' + this.$i18n.t('table.value.min') + ')').toUpperCase()] = "minPrice"
            ret[(this.$i18n.t('table.header.price') + '(' + this.$i18n.t('table.value.max') + ')').toUpperCase()] = "maxPrice"
            ret[(this.$i18n.t('table.header.active')).toUpperCase()] = "isActive"
            return ret
        },
    },
    watch:{
        "$i18n.locale"(val){
            this.setExportData(this.treatmentExportData)
        }
    },
    methods:{
        getImage(img){
            return img
        },
        formatPrice(price){
            return formatPrice(price);
        },
        closeModal(isError){
            if(!isError){
                if(this.$refs.deleteModal.toggleModal){
                    this.$refs.deleteModal.toggleModal = false
                    this.filterTreatment()
                }
            }
            
            this.$parent.$parent.isModalShow = false
        },
        sortTable(a, b, key, sortDesc){
            if(key == "price"){
                var aPrice = 0
                var bPrice = 0
                if(sortDesc){
                    aPrice = a.TnTreatmentMaxPrice
                    bPrice = b.TnTreatmentMaxPrice
                }else{
                    aPrice = a.TnTreatmentMinPrice
                    bPrice = b.TnTreatmentMinPrice
                }
                return aPrice - bPrice
            }
            return false
        },
        filterTreatment(){
            let QUERY_STRING = ""
            this.setTreatment(QUERY_STRING)

        },
        async setTreatment(strFilter){
            this.isSpinnerShow = true
            var result = await this.getTreatment("?page=" + this.page + strFilter)
            var res = await this.getTherapy()
            var voucher = await this.getVoucherItems()

            res.forEach(item=>{
                var obj = voucher.filter(obj=>obj.itemID === item.TnTherapyVoucherID)[0];
                item.TnTherapyVoucherName = obj.title;
            });

            var therapyGroup = _.groupBy(res, 'TnTreatmentID')
            var therapy = _.orderBy(therapyGroup, ['TnTreatmentID'], ['asc'])

           result.result.forEach(item=>{
                var TnTherapy = therapy.filter(obj=>obj[0].TnTreatmentID===item.TnTreatmentID);
                item.TnTherapy = TnTherapy;
            });

            this.totalEntries = result.count

            var retData = setReturnData(result.result, result.count, this.page)
            this.treatmentItems = _.orderBy(retData.result, ['TnTreatmentCreateDate'], ['desc']) ;
            this.totalPage = retData.totalPage;

            this.startPage = retData.startPage;
            this.endPage = retData.endPage;
            
            this.isSpinnerShow = false
            var exp = await this.getTreatment("?" + strFilter)

            exp.result.forEach(item=>{
                var TnTherapy = therapy.filter(obj=>obj[0].TnTreatmentID===item.TnTreatmentID);
                item.TnTherapy = TnTherapy;
            });
            this.treatmentExportData = exp.result
            this.setExportData(this.treatmentExportData)
        },
        async getTreatment(strFilter){
            let $vm = this;
            const url =  this.$api.MENU_TREATMENT + strFilter;

            var result = {}

            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
        async getTherapy(){
            let $vm = this;

            var result = {}

            await $vm.$axios({
                method: 'get', 
                url: this.$api.MENU_THERAPY,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
        async getVoucherItems(){
            let $vm = this;
            let QUERY_STRING =  "?type=service" 
            const url =  this.$api.MENU_ITEM + QUERY_STRING;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.items;
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
        setExportTreatmentObj(i, obj){
            var data = {
                index: i+1,
                treatment: obj.TnTreatmentName,
                therapy: '',
                details: obj.TnTreatmentDetails == '' ? '-' : obj.TnTreatmentDetails,
                voucher: '',
                unitPrice: '',
                minPrice: obj.TnTreatmentMinPrice,
                maxPrice: obj.TnTreatmentMaxPrice,
                isActive: obj.TnTreatmentActive == 1 ? this.$i18n.t('table.value.active') : this.$i18n.t('table.value.inactive'),
            }
            return data
        },
        setExportTherapyObj(o){
            var data = {
                index: '',
                treatment: '',
                therapy: o.TnTherapyName,
                details: o.TnTherapyDetails == '' ? '-' : o.TnTherapyDetails,
                voucher: o.TnTherapyVoucherName,
                unitPrice: o.TnTherapyUnitPrice,
                minPrice: '',
                maxPrice: '',
                isActive: '',
            }
            return data
        },
        setExportData(data){
            let $vm = this
            this.exportData = []
            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_menu_treatment`)
            this.exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24)," "];
            this.exportFileName =  header.split(" ").join("_") +  this.$msg.REPORT.CSV

            var exportData = []
            data.forEach(function(obj, i){ 
                exportData.push($vm.setExportTreatmentObj(i, obj))
                if(obj.TnTherapy.length != 0){
                    if(obj.TnTherapy[0].length != 0){
                        obj.TnTherapy[0].forEach(function (o){
                            exportData.push($vm.setExportTherapyObj(o))
                        })
                    }
                }
                
            })
            this.exportData = exportData
        },
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1
                this.filterTreatment();
            }
        },
        showEdit(item){
            this.$refs.treatmentTherapyForm.editItem(item)
            // this.sTitle = item.TnTreatmentName
            // this.$refs.treatmentForm.editTreatment(item)
            // this.editToggleModal = true
        },
        showDelete(item){
            this.itemID = item.TnTreatmentID
            this.selectedTherapy = item.TnTherapy[0]
            var title = this.$i18n.t('button_link.delete') + this.$i18n.t('subMenu.salon_menu_treatment')
            var message = this.$i18n.t('message.confirmation.question', {'action': this.$i18n.t('message.confirmation.action.delete'), 'item': item.TnTreatmentName})
            this.$refs.deleteModal.showModal(title, message)
        },
        deleteTherapy(id){    
            let $vm = this
            const url =  $vm.$api.MENU_THERAPY + "/" + id + $vm.$api.DELETE;
            
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
            })
            .then((response) => {
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        deleteTreatment(){
            let $vm = this
            const url =  $vm.$api.MENU_TREATMENT + "/" + this.itemID + $vm.$api.DELETE;
            
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
            })
            .then((response) => {
                if(response.status == 200){
                    var message = $vm.$i18n.t('subMenu.salon_menu_treatment') + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.delete')})
                    $vm.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })

            for(var i=0; i<this.selectedTherapy.length; i++){
                this.deleteTherapy(this.selectedTherapy[i].TnTherapyID)
            }
        },
        returnTreatment(){
            this.filterTreatment();
            this.addToggle = this.editToggleModal = false
        },
    },
    mounted(){
        let $vm = this
        $vm.filterTreatment()
    }
}
</script>
<style scoped>
.img-treatment{
    width: 12em;
}
.nav-link{
    cursor: pointer;
}
.show{
    display: block;
}
.border-top-bottom-2{
    border-top: 3px solid rgb(219, 219, 219) !important;
    /* border-top-width:  3px !important; */
    border-bottom-width:  1px !important;
}
</style>